(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["obapet-harness-colors"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('obapet-harness-colors'))customElements.define('obapet-harness-colors',class extends HTMLElement{connectedCallback(){this.abort?.abort();this.abort=new AbortController();this.picker=this.closest('.product-information')?.querySelector('variant-picker')||document.querySelector('variant-picker[data-template-product-match="true"]');if(!this.picker)return;this.render=()=>{const wanted=this.dataset.option.trim().toLowerCase();const group=[...this.picker.querySelectorAll('fieldset')].find(x=>x.querySelector('legend')?.textContent.trim().toLowerCase().startsWith(wanted));if(!group)return;group.classList.add('obh-color-fieldset');group.style.setProperty('--obh-colour-selected',this.dataset.accent);const images=new Map([...this.querySelectorAll('[data-color]')].map(x=>[x.dataset.color,x.dataset.src]));group.querySelectorAll('label').forEach(label=>{const input=label.querySelector('input');if(!input)return;const src=images.get(input.value);if(!src||label.querySelector('img[data-obapet-colour]'))return;const img=document.createElement('img');img.src=src;img.alt='';img.dataset.obapetColour='';img.loading='lazy';label.prepend(img)})};this.render();this.observer=new MutationObserver(()=>this.render());this.observer.observe(this.picker,{childList:true,subtree:true})}disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.picker?.querySelector('.obh-color-fieldset')?.classList.remove('obh-color-fieldset')}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["obapet-harness-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('obapet-harness-offer')) {
    customElements.define('obapet-harness-offer', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.toggle = this.querySelector('[data-offer-toggle]');
        this.scope = this.closest('.product-information') || document;
        this.sync = () => {
          const picker = this.scope.querySelector('variant-picker[data-template-product-match="true"]') || this.scope.querySelector('variant-picker');
          const wanted = this.dataset.setName.trim().toLowerCase();
          this.group = [...picker?.querySelectorAll('fieldset') || []].find(group => group.querySelector('legend')?.textContent.trim().toLowerCase().startsWith(wanted));
          const withLead = [...this.group?.querySelectorAll('input') || []].find(input => input.value === this.dataset.withLead);
          const checked = this.group?.querySelector('input:checked');
          this.toggle.checked = checked?.value === this.dataset.withLead;
          this.toggle.disabled = !withLead || withLead.disabled || withLead.getAttribute('aria-disabled') === 'true';
        };
        this.frame = requestAnimationFrame(this.sync);
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.scope, {childList:true, subtree:true});
        this.toggle.addEventListener('change', () => {
          const value = this.toggle.checked ? this.dataset.withLead : this.dataset.withoutLead;
          const input = [...this.group?.querySelectorAll('input') || []].find(candidate => candidate.value === value);
          if (input && !input.disabled && input.getAttribute('aria-disabled') !== 'true') input.click();
          this.frame = requestAnimationFrame(this.sync);
        }, {signal:this.abort.signal});
        document.addEventListener('change', event => {
          if (event.target.closest?.('variant-picker')) this.frame = requestAnimationFrame(this.sync);
        }, {signal:this.abort.signal});
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["obapet-purchase-info"] && !Shopify.designMode) return;
  try {
    class ObapetPurchaseInfo extends HTMLElement {
    connectedCallback(){
      const range=this.querySelector('[data-delivery-range]');
      const min=Number(this.dataset.min),max=Number(this.dataset.max);
      if(!range||!Number.isInteger(min)||!Number.isInteger(max)||min<=0||max<min||max>365)return;
      const start=new Date();start.setHours(12,0,0,0);
      const addDays=count=>{const date=new Date(start);let days=0;while(days<count){date.setDate(date.getDate()+1);if(this.dataset.businessDays!=='true'||(date.getDay()!==0&&date.getDay()!==6))days++;}return date;};
      const language=document.documentElement.lang||'en';
      const locale=language.split('-')[0]==='en'?'en-GB':language;
      const first=addDays(min),last=addDays(max);
      const month=['long','short','numeric'].includes(this.dataset.month)?this.dataset.month:'long';
      const options={month,day:'numeric'};
      if(first.getFullYear()!==last.getFullYear())options.year='numeric';
      const format=new Intl.DateTimeFormat(locale,options);
      const firstFormat=first.getMonth()===last.getMonth()&&first.getFullYear()===last.getFullYear()&&month!=='numeric'?new Intl.DateTimeFormat(locale,{day:'numeric'}):format;
      range.textContent=min===max?format.format(first):`${firstFormat.format(first)} ${this.dataset.separator||'–'} ${format.format(last)}`;
    }
  }
  if(!customElements.get('obapet-purchase-info'))customElements.define('obapet-purchase-info',ObapetPurchaseInfo);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["obapet-reels"] && !Shopify.designMode) return;
  try {
    class ObapetReels extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('play', event => {
        if (!(event.target instanceof HTMLVideoElement)) return;
        document.querySelectorAll('obapet-reels video').forEach(video => { if (video !== event.target) video.pause(); });
      }, { capture:true, signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
      }, { signal });
      this.observer = new IntersectionObserver(entries => { entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); }); }, { threshold:.1 });
      this.querySelectorAll('video').forEach(video => this.observer.observe(video));
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  }
  if (!customElements.get('obapet-reels')) customElements.define('obapet-reels', ObapetReels);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["obapet-second-look"] && !Shopify.designMode) return;
  try {
    class ObapetSecondLook extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      if (this.dataset.layout === 'carousel') { this.initCarousel(signal); return; }
      this.variants = JSON.parse(this.querySelector('[data-primary-variants]').textContent);
      this.primary = this.variants.find(v => String(v.id) === this.dataset.variantId);
      this.partner = this.querySelector('[data-partner-select]');
      this.button = this.querySelector('[data-add-pair]');
      this.status = this.querySelector('[data-pair-status]');
      this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:this.dataset.currency || 'USD' });
      this.addEventListener('change', () => this.update(), { signal });
      this.button.addEventListener('click', () => this.addPair(), { signal });
      this.querySelector('[data-change-size]')?.addEventListener('click', () => {
        const picker = this.closest('.shopify-section')?.querySelector('variant-picker');
        picker?.scrollIntoView({ behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'center' });
        picker?.querySelector('input:checked, select, button')?.focus({ preventScroll:true });
      }, { signal });
      this.closest('.shopify-section')?.addEventListener('variant:selected', () => { this.changing = true; this.button.disabled = true; }, { signal });
      this.closest('.shopify-section')?.addEventListener('variant:update', event => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        this.primary = this.variants.find(v => String(v.id) === String(event.detail?.resource?.id));
        this.changing = false;
        this.update();
      }, { signal });
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.resizeObserver?.disconnect(); }
    initCarousel(signal) {
      this.track = this.querySelector('[data-quick-track]');
      this.status = this.querySelector('[data-pair-status]');
      this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:this.dataset.currency || 'USD' });
      this.addEventListener('submit', event => {
        const form = event.target.closest('[data-quick-form]');
        if (!form) return;
        event.preventDefault();
        if (!this.busy) this.addSingle(form);
      }, { signal });
      this.addEventListener('change', event => {
        const form = event.target.closest('[data-quick-form]');
        if (form) this.updateQuickCard(form);
      }, { signal });
      this.addEventListener('click', event => {
        const arrow = event.target.closest('[data-quick-slide]');
        if (!arrow) return;
        const width = this.track.querySelector('article')?.getBoundingClientRect().width || 160;
        this.track.scrollBy({ left:Number(arrow.dataset.quickSlide) * (width + 10), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal });
      this.track.addEventListener('scroll', () => this.updateArrows(), { signal, passive:true });
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      this.resizeObserver.observe(this.track);
      this.querySelectorAll('[data-quick-form]').forEach(form => this.updateQuickCard(form));
      this.closest('.shopify-section')?.addEventListener('variant:update', event => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        const form = this.querySelector(`[data-quick-form][data-product-id="${this.dataset.productId}"]`);
        const select = form?.querySelector('select');
        if (select && [...select.options].some(option => option.value === String(event.detail?.resource?.id))) {
          select.value = String(event.detail.resource.id);
          this.updateQuickCard(form);
        }
      }, { signal });
      this.updateArrows();
    }
    updateArrows() {
      const previous = this.querySelector('[data-quick-slide="-1"]');
      const next = this.querySelector('[data-quick-slide="1"]');
      if (previous) previous.disabled = this.track.scrollLeft <= 2;
      if (next) next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    }
    updateQuickCard(form) {
      const input = form.querySelector('[name="id"]');
      const option = input.selectedOptions?.[0] || input;
      form.querySelector('[data-quick-price]').textContent = this.money(Number(option.dataset.price || 0));
      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = !!this.busy || option.dataset.available !== 'true';
    }
    async addSingle(form) {
      const input = form.querySelector('[name="id"]');
      const selected = input.selectedOptions?.[0] || input;
      if (selected.dataset.available !== 'true') return;
      this.busy = true;
      this.status.textContent = this.dataset.addingLabel;
      this.setAttribute('aria-busy', 'true');
      const controls = [...this.querySelectorAll('[data-quick-form] select, [data-quick-form] button')].filter(el => !el.disabled);
      controls.forEach(el => { el.disabled = true; });
      const root = window.Shopify?.routes?.root || '/';
      const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0, 5);
      let added = false;
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
          body:JSON.stringify({ items:[{ id:Number(input.value), quantity:1 }], sections, sections_url:location.pathname })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.errorLabel);
        added = true;
        let cart;
        try { const cartResponse = await fetch(`${root}cart.js`); if (cartResponse.ok) cart = await cartResponse.json(); } catch {}
        this.dispatchEvent(new CustomEvent('cart:update', { bubbles:true, detail:{ resource:cart, sourceId:this.id, data:{ source:'obapet-second-look', itemCount:1, productId:form.dataset.productId, sections:result.sections } } }));
        this.status.textContent = this.dataset.singleAddedLabel;
        this.querySelector('[data-cart-link]').hidden = false;
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      } catch (error) {
        this.status.textContent = added ? this.dataset.singleAddedLabel : `${error.message || this.dataset.errorLabel} ${this.dataset.checkLabel}`;
        this.querySelector('[data-cart-link]').hidden = false;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        controls.forEach(el => { if (el.isConnected) el.disabled = false; });
        this.querySelectorAll('[data-quick-form]').forEach(item => this.updateQuickCard(item));
      }
    }
    money(cents) { return this.formatter.format(cents / 100); }
    update() {
      const id = this.partner.value;
      this.querySelectorAll('[data-partner-panel]').forEach(el => { el.hidden = el.dataset.partnerPanel !== id; });
      this.querySelectorAll('[data-partner-variants]').forEach(el => { el.hidden = el.dataset.partnerVariants !== id; });
      this.secondary = this.querySelector(`[data-partner-variants="${id}"] select`)?.selectedOptions[0];
      const price = Number(this.secondary?.dataset.price || 0);
      this.querySelector('[data-partner-price]').textContent = this.money(price);
      const primaryPrice = this.primary?.price || 0;
      this.querySelector('[data-first-price]').textContent = this.primary ? this.money(primaryPrice) : this.dataset.unavailableLabel;
      const title = this.querySelector('[data-first-variant]');
      if (title) title.textContent = this.primary?.title || '—';
      const image = this.querySelector('[data-first-image]');
      if (image && this.primary?.image) { image.src = this.primary.image; image.removeAttribute('srcset'); }
      const total = primaryPrice + price;
      const discount = Math.round(Math.min(primaryPrice, price) * Number(this.dataset.discount) / 100);
      this.querySelector('[data-pair-total]').textContent = this.primary ? this.money(total - discount) : '—';
      const original = this.querySelector('[data-original-total]');
      original.hidden = !discount || !this.primary;
      original.textContent = this.money(total);
      this.button.disabled = !!this.busy || !!this.changing || !this.primary?.available || this.secondary?.dataset.available !== 'true';
    }
    async addPair() {
      if (this.button.disabled || this.busy) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.addingLabel;
      this.status.textContent = '';
      this.querySelector('[data-cart-link]').hidden = true;
      const root = window.Shopify?.routes?.root || '/';
      const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0, 5);
      const items = [{ id:Number(this.primary.id), quantity:1 }, { id:Number(this.secondary.value), quantity:1 }];
      let added = false;
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
          body:JSON.stringify({ items, sections, sections_url:location.pathname })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.errorLabel);
        added = true;
        let cart;
        try { const cartResponse = await fetch(`${root}cart.js`); if (cartResponse.ok) cart = await cartResponse.json(); } catch {}
        this.dispatchEvent(new CustomEvent('cart:update', { bubbles:true, detail:{ resource:cart, sourceId:this.id, data:{ source:'obapet-second-look', itemCount:2, productId:this.dataset.productId, sections:result.sections } } }));
        this.status.textContent = this.dataset.addedLabel;
        this.querySelector('[data-cart-link]').hidden = false;
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      } catch (error) {
        this.status.textContent = added ? this.dataset.addedLabel : `${error.message || this.dataset.errorLabel} ${this.dataset.checkLabel}`;
        this.querySelector('[data-cart-link]').hidden = false;
      } finally {
        this.busy = false;
        this.button.textContent = this.dataset.addLabel;
        this.update();
      }
    }
  }
  if (!customElements.get('obapet-second-look')) customElements.define('obapet-second-look', ObapetSecondLook);
  } catch(e) { console.error(e); }
})();

})();
